export const applyMask = (
  value: string,
  rules: Array<[RegExp, string]>
): string => {
  let formattedValue = value;
  rules?.forEach(([regex, replacement]) => {
    formattedValue = formattedValue.replace(regex, replacement);
  });

  return formattedValue;
};
